export default __webpack_public_path__ + "static/media/ficha_periodontal.54355b4a.pdf";